module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "chapter06"
    }
  }), _vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Conceit is rarely regarded as a fault among the very rich and powerful. Indeed, it is often mistaken for the confidence which enables them to obtain their riches and position. And often it is the frailty which leads to their undoing. Giuseppe Terrilli knew about conceit and its dangers and he was therefore confident he would never become a victim of it, any more than he would ever become a victim of any human failing, which he recognised was a conceit in itself, but still not a problem because he acknowledged it and could guard against it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All his life Terrilli had guarded against what he considered weakness. He had loved his wife absolutely and had seen no contradiction in his readiness to kill her if she had become attracted to someone else, not because of any sexual betrayal but because she might have revealed his secrets. He accepted that he might have enjoyed the effect of alcohol or drugs, but abstained from both because he knew they would weaken his self-control, and there had never been a moment, not since he was eight years old and had pushed his elder brother to his death from the top of their tenement building in New York’s Little Italy and then held back from the instinct to look over the parapet to see what had happened, knowing someone below might look up and identify him, when Terrilli had not known complete self-control.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With such self-awareness, Terrilli knew the risk of what he was contemplating; like the alcoholic, in brief moments of sobriety, accepts that gin is destroying his liver or the heroin addict that each injection increases the possibility of an aneurysm in the brain. But unlike the man who declares the drink to be his last or the addict convinced the fix will be the final one before the cure, Terrilli was sure he could make it work. And the feeling was confidence, not conceit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It just needed planning; the sort of planning he had put into establishing the narcotics operation as one of the most lucrative within the organisation, grossing more than the country-wide prostitution or Las Vegas gambling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was from the criticism of the organisation rather than any police involvement that Terrilli considered it important to protect himself, which was why it had to be an outside operation, organised personally by himself, and not something he could delegate to Tony Santano. If he told Santano, then Santano would tell the organisation. And then there would be a meeting of reasonable men to convince him he was being unreasonable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Terrilli was sure that Robert Chambine was the perfect choice for the robbery. For over two years the man had been trying to transfer from New York to Florida, to become part of the family there. And for two years Terrilli had held him off, waiting until Chambine could be put into a position to provide something. The exhibition was to be his chance, and Chambine knew it. If he succeeded, then he would be made one of Terrilli’s lieutenants. If he failed, Terrilli would have him killed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m grateful for the opportunity,’ Chambine said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Terrilli had had drinks installed in the Waldorf Astoria suite, but Chambine had seen the older man take just club soda and so he asked for the same, determined to impress in every way possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It is to be a personal thing,’ said Terrilli. There was always the chance that Chambine would inform upon him to the organisation, to ingratiate himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I understand,’ said Chambine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I would take it as an insult to myself if it were discussed.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You can trust me,’ Chambine assured him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I hope I can. How many people will you need?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve got to see the size of the exhibition, but I wouldn’t think more than six.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Can you find them?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Discreetly?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You have my guarantee. What is the security like?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Appears to be nothing more than normal.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sure you don’t want the collection taken here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Terrilli shook his head. ‘Too soon. Everyone will be alert now. By the time the second week comes in Florida, they will have become complacent and sloppy.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘As soon as I’ve seen the stamps, tomorrow, I shall go to Palm Beach. I’ve already made a reservation at the Breakers.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Terrilli nodded his appreciation at the man’s initiative. Chambine was a thick-set, muscular man who had the habit of clenching and relaxing his hands when he was talking, as if squeezing a ball. He was unobtrusively dressed, which Terrilli liked, just as he liked the man’s attitude, properly respectful without any servility. He wanted Chambine to succeed and not just because he was determined to have the Romanov Collection. Terrilli was growing increasingly uneasy at Santano’s position: it would be good to have someone loyal alongside him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Contact will always come from me,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And I want everything brought to my house. Immediately.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chambine frowned and Terrilli smiled at the surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No one would dream of suspecting me of any involvement,’ he explained. ‘I’m well regarded within the community.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What am I to offer the others?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fifty thousand each,’ said Terrilli immediately. He waited for fresh surprise to show, but this time Chambine curbed it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s a great deal of money,’ said Chambine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For that, I want the best.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’ll get it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And you receive a hundred thousand,’ said Terrilli.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This time Chambine smiled. ‘You’re very generous.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I want the stamps.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Consider them yours.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Without any trouble,’ Terrilli warned him. ‘I don’t want over-confidence.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My word.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’d like us to work together.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’d like that too, Mr Terrilli.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We’ll make it the Thursday of the second week. I’ll have to warn my own security people, otherwise you won’t be able to get into the grounds.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That will give me more than sufficient time.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Terrilli stood up and the other man rose with him. ‘I don’t like violence,’ said Terrilli.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll see it’s avoided.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t mind if it’s the only way … I’d just prefer a clean job, without any killing.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Terrilli walked to a desk against one wall, alongside which was his snakeskin briefcase. He took out several bundles of money, still in their bank wrappers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fifty thousand on account and for advance expenses for the people you’ll take with you,’ he said. ‘I’d like you to count it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chambine did as he was told. Terrilli watched without speaking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fifty thousand,’ agreed Chambine finally. He looked up. ‘Please don’t think me presumptuous,’ he said. ‘But you shouldn’t carry such amounts around unless you have people with you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why not?’ demanded Terrilli curiously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Crime.’ said Chambine. ‘Despite what the police claim, there’s still an amazing amount of it on the streets. It’s not safe.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘People shouldn’t put up with it,’ said Terrilli seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Charlie didn’t bother to undress, familiar with the rich-woman-amusing-herself routine and guessing she would come. There was a knock within an hour. Clarissa walked straight in when he opened the door, without greeting. When he turned, she was frowning at the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s not a suite,’ she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I was expecting a suite.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sorry.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just as I was expecting courtesy tonight.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I was courteous,’ said Charlie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You humiliated me, walking away like that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s not really important, but the humiliation was yours. I don’t do tricks to finger-snapping.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You mean you’re not like my husband?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Have it which ever way you want.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I intend to,’ she said, turning the expression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie walked further into the room, looking down upon the woman. Clarissa had seated herself on the bed, shoes thrown off. Perhaps her feet hurt, too, he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why don’t you go to bed?’ he said sadly. Her eyes were fogged and he didn’t think it was from alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I want you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sighed, irritated by her. ‘I don’t fuck to order, either.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This time you do.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie sat down in a chair, some way from the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stop it, Clarissa,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Because unless you do, I shan’t tell you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tell me what?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who is making enquiries about you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who?’ Charlie’s concern was immediate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nothing’s for nothing.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Later.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No. Earn it first.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was always on his knees to someone, thought Charlie. And fifteen minutes later he literally was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s very nice,’ she said. ‘I knew it would be nice. Here.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I brought you a toothpick from the restaurant.’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d004de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/chapter06.vue
// module id = 102
// module chunks = 0